import React, { useEffect, useState } from 'react';
import { raiseClaimService } from '../../services';
import { decimalNum, required, policyRegexHyphenSlashScore, noEscChar } from '../../helpers/commonYupValidations';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Table, Button } from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from "moment";
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'reactstrap';
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import SalvageAmount from './SalvageAmount';
import { formatDate } from '../../helpers/common';
import { aesUtil } from '../../utils/aesUtil';

const ClaimSettlement = ({ claimDetails, fetchClaimTemplateDetails, raiseClaimId }) => {
    const claimIntimationDate = claimDetails?.claimIntimationDate;
    const parsedclaimIntimationDate = claimIntimationDate ? moment(claimIntimationDate, "DD-MM-YYYY").toDate() : null;

    const getAssesmentLabel = () => {
        const estimatedLoss = claimDetails?.estimatedLoss;
        if (estimatedLoss && estimatedLoss > 25000) {
            return 'Surveyor Assessment Amount'
        } else {
            return 'Assessment Amount'
        }
    }

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [claimSettlementList, setClaimSettlementList] = useState(null)
    let data = localStorage.getItem('token');
    const decryptToken = typeof data === 'string' ? aesUtil.decrypt(data) : '';
    const decoded = typeof decryptToken === 'string' ? jwtDecode(decryptToken) : null; const userRole = decoded?.Role;

    const canAddAssesmentAmt = () => {
        const isSTPPolicy = claimDetails?.policyName?.toLowerCase().includes('stp');
        const isSTPNotZeroOrOne = isSTPPolicy && !(claimDetails?.policyName?.toLowerCase() === 'stp0' || claimDetails?.policyName?.toLowerCase() === 'stp 0' || claimDetails?.policyName?.toLowerCase() === 'stp 1' || claimDetails?.policyName?.toLowerCase() === 'stp1');
        const isEstimatedBelOrEq25000 = (claimDetails?.estimatedLoss < 25000) || (claimDetails?.estimatedLoss == 25000);
        const isClaimMarine = claimDetails?.storageTransitType?.toLowerCase() === 'transit';

        const isMisc = claimDetails?.policyType?.toLowerCase().includes('misc') || claimDetails?.policyType?.toLowerCase().includes('miscellaneous');
        const isMiscPolicy = isMisc && claimDetails?.policyName?.toLowerCase().includes('PEEI'.toLocaleLowerCase()) || claimDetails?.policyName?.toLowerCase().includes('EEI'.toLocaleLowerCase()) || claimDetails?.policyName?.toLowerCase().includes('GPA'.toLowerCase())
        const isGroupMedical = claimDetails?.policyType?.toLowerCase().includes('Group Medical'.toLowerCase())

        return (isSTPNotZeroOrOne && isEstimatedBelOrEq25000 && isClaimMarine && userRole === 'Insurer') || (isMisc && isMiscPolicy && userRole === 'Insurer') || (isGroupMedical && userRole === 'Insurer') || (userRole === 'Surveyor');
    }

    const editClaimSettlementValidationSchema = Yup.object().shape({
        surveyorAssesmentAmount:
            !canAddAssesmentAmt()
                ?
                Yup.string().notRequired().matches(noEscChar(`${getAssesmentLabel()}`).regex, noEscChar(`${getAssesmentLabel()}`).msg) :
                Yup.string().matches(noEscChar(`${getAssesmentLabel()}`).regex, noEscChar(`${getAssesmentLabel()}`).msg)
                    .test('mandatory-validation', `${getAssesmentLabel()} is required`, function (value) {
                        return true;
                    })
                    .test(
                        'is-greater-than-zero',
                        `${getAssesmentLabel()} must be greater than 0`,
                        function (value) {
                            const surveyorAssesmentAmount = value ? parseFloat(value) : 0;
                            if (surveyorAssesmentAmount || surveyorAssesmentAmount == 0) {
                                return (
                                    surveyorAssesmentAmount > 0
                                );
                            } else {
                                return true
                            }
                        }).matches(decimalNum(10, 3, `${getAssesmentLabel()}`).regex, decimalNum(10, 3, `${getAssesmentLabel()}`).msg)
                    .required(required(`${getAssesmentLabel()}`).msg),
        claimSettlementListOnAccount: userRole === "Insurer" && Yup.array().of(
            Yup.object().shape({
                insurerApprovedAmount: Yup.string()
                    .matches(noEscChar("On Account Amount").regex, noEscChar("On Account Amount").msg)
                    .test('onaccountamount-mandatory-validation', 'On Account Amount is required', function (value) {
                        const { utrNumber, utrDate } = this.parent;
                        const hasAnyValue = value || utrNumber || utrDate;
                        if (hasAnyValue) {
                            return !!value;
                        }
                        return true;
                    })
                    .test('is-greater-than-zero', 'On Account Amount must be greater than 0', function (value) {
                        const { utrNumber, utrDate } = this.parent;
                        const hasAnyValue = value || utrNumber || utrDate;
                        if (hasAnyValue) {
                            const amount = value ? parseFloat(value) : 0;
                            if (amount || amount === 0) {
                                return amount > 0;
                            }
                            return true;
                        }
                        return true;
                    })
                    .matches(decimalNum(10, 3, 'On Account Amount').regex, decimalNum(10, 3, 'On Account Amount').msg),

                utrNumber: Yup.string()
                    .matches(noEscChar("UTR No.").regex, noEscChar("UTR No.").msg)
                    .max(100, 'UTR No. must be less than 100 characters')
                    .matches(policyRegexHyphenSlashScore('UTR No.').regex, policyRegexHyphenSlashScore('UTR No.').msg)
                    .test('utr-no-validation', 'UTR No. is required', function (value) {
                        const { insurerApprovedAmount, utrDate } = this.parent;
                        const hasAnyValue = insurerApprovedAmount || value || utrDate;
                        if (hasAnyValue) {
                            return !!value;
                        }
                        return true;
                    }),

                utrDate: Yup.date()
                    .nullable()
                    .test('utr-date-required', required('UTR Date').msg, function (value) {
                        const { insurerApprovedAmount, utrNumber } = this.parent;
                        const hasAnyValue = insurerApprovedAmount || utrNumber || value;
                        if (hasAnyValue) {
                            return !!value;
                        }
                        return true;
                    })
            })
        ),
    });

    const getClaimSettlement = async () => {
        const payload = { claimId: claimDetails?.raiseClaimId }
        setIsLoading(true)
        const response = await raiseClaimService.getClaimSettlement(payload)
        if (response?.data?.isSuccess) {
            let settledAmounts = response.data.data[0]?.insurerData.filter(item => item.amountType === "Settled Amount");
            let accountPayments = response.data.data[0]?.insurerData.filter(item => item.amountType === "Account Payment");
            let salvageAmount = response.data.data[0]?.insurerData.filter(item => item.amountType === "Salvage");
            setClaimSettlementList({ settledAmounts, accountPayments, salvageAmount })
        }
        setIsLoading(false)
    }
    const addClaimSettlement = async (values) => {

        let insurerData = values.claimSettlementListOnAccount;
        insurerData = insurerData.some(item => parseFloat(item.insurerApprovedAmount) > 0)
            ? insurerData
            : null;

        let payload = {}

        if (userRole !== "Surveyor") {
            payload = {
                claimRaiseId: raiseClaimId,
                //settlementType: "Partially",
                surveyorAssesmentAmount: values.surveyorAssesmentAmount || 0,
                //insurerData: insurerData,
            }
            if (insurerData) {
                payload.settlementType = "Partially"
                payload.insurerData = insurerData
            }
        } else {
            payload = {
                claimRaiseId: raiseClaimId,
                surveyorAssesmentAmount: values.surveyorAssesmentAmount || 0,
            }
        }

        setIsSubmitted(true)
        const response = await raiseClaimService.addClaimSettlement(payload);
        if (response?.data?.isSuccess) {
            await getClaimSettlement();
            await fetchClaimTemplateDetails(raiseClaimId);
            toast.success(response?.data?.message);
        } else {
            toast.error(response?.data?.message);
        }
        setIsSubmitted(false)
    }

    useEffect(() => {
        const fetchList = async () => {
            await getClaimSettlement()
        };
        fetchList();
    }, []);

    return (
        <div>
            <SalvageAmount getClaimSettlement={getClaimSettlement} claimSettlementList={claimSettlementList} claimDetails={claimDetails} fetchClaimTemplateDetails={fetchClaimTemplateDetails} raiseClaimId={raiseClaimId} />
            <div className='fieldArrayBox'>
                <Formik
                    initialValues={{
                        surveyorAssesmentAmount: claimDetails?.surveyorAssesmentAmount || "",
                        claimSettlementListOnAccount: [{ id: 0, amountType: "Account Payment", insurerApprovedAmount: "", reInstatementPremium: 0, utrNumber: '', utrDate: null }],
                    }}
                    validationSchema={editClaimSettlementValidationSchema}
                    onSubmit={addClaimSettlement}
                    enableReinitialize
                >
                    {({ dirty, errors, touched, setFieldValue, setFieldTouched, values }) => {
                        return <Form>
                            <div>
                                <div className="form-group">
                                    <div className='fieldArrayBox'>
                                        <label htmlFor="surveyorAssesmentAmount">{getAssesmentLabel()}</label>
                                        <Field
                                            type="text"
                                            className="form-control"
                                            id="surveyorAssesmentAmount"
                                            name="surveyorAssesmentAmount"
                                            placeholder={`Enter ${getAssesmentLabel()}`}
                                            disabled={!canAddAssesmentAmt()}
                                        />
                                        {errors?.surveyorAssesmentAmount && touched?.surveyorAssesmentAmount ? (
                                            <p className="errorMsg">{errors?.surveyorAssesmentAmount}</p>) : null}

                                    </div>
                                    <div className='mt-3'>
                                        {userRole === "Surveyor" || claimDetails?.paymentStatus === "Settled" ? null :
                                            <Accordion>
                                                <AccordionItem>
                                                    <AccordionHeader style={{ pointerEvents: 'none' }}>
                                                        <div>On Account Payment</div>
                                                    </AccordionHeader>
                                                    <AccordionBody>
                                                        <FieldArray name="claimSettlementList">
                                                            {() => (
                                                                <div>
                                                                    {values?.claimSettlementListOnAccount?.length > 0 &&
                                                                        values?.claimSettlementListOnAccount?.map((settlement, index) => (
                                                                            <div className="d-flex flex-wrap" style={{ justifyContent: "space-between" }} key={settlement?.id}>
                                                                                <div className="form-group fieldArrayBox" style={{ width: "35%" }}>
                                                                                    <label htmlFor={`claimSettlementListOnAccount.${index}.insurerApprovedAmount`}>Amount *</label>
                                                                                    <Field
                                                                                        type="text"
                                                                                        className={`form-control ${touched.claimSettlementListOnAccount?.[index]?.insurerApprovedAmount &&
                                                                                            errors.claimSettlementListOnAccount?.[index]?.insurerApprovedAmount
                                                                                            ? "is-invalid"
                                                                                            : ""
                                                                                            }`}
                                                                                        id={`claimSettlementListOnAccount.${index}.insurerApprovedAmount`}
                                                                                        name={`claimSettlementListOnAccount.${index}.insurerApprovedAmount`}
                                                                                        placeholder="Enter On Account Amount"
                                                                                    />
                                                                                    {errors.claimSettlementListOnAccount?.[index]?.insurerApprovedAmount &&
                                                                                        touched.claimSettlementListOnAccount?.[index]?.insurerApprovedAmount && (
                                                                                            <p className="errorMsg">{errors.claimSettlementListOnAccount[index].insurerApprovedAmount}</p>
                                                                                        )}
                                                                                </div>
                                                                                <div className="form-group fieldArrayBox" style={{ width: "30%" }}>
                                                                                    <label htmlFor={`claimSettlementListOnAccount.${index}.utrNumber`}>UTR No. *</label>
                                                                                    <Field
                                                                                        type="text"
                                                                                        className={`form-control ${touched.claimSettlementListOnAccount?.[index]?.utrNumber &&
                                                                                            errors.claimSettlementListOnAccount?.[index]?.utrNumber
                                                                                            ? "is-invalid"
                                                                                            : ""
                                                                                            }`}
                                                                                        id={`claimSettlementListOnAccount.${index}.utrNumber`}
                                                                                        name={`claimSettlementListOnAccount.${index}.utrNumber`}
                                                                                        placeholder="Enter UTR Number"
                                                                                    />
                                                                                    {errors.claimSettlementListOnAccount?.[index]?.utrNumber &&
                                                                                        touched.claimSettlementListOnAccount?.[index]?.utrNumber && (
                                                                                            <p className="errorMsg">{errors.claimSettlementListOnAccount[index].utrNumber}</p>
                                                                                        )}
                                                                                </div>
                                                                                <div className="form-group fieldArrayBox" style={{ width: "30%" }}>
                                                                                    <label htmlFor={`claimSettlementListOnAccount.${index}.utrDate`}>UTR Date *</label>
                                                                                    <DatePicker
                                                                                        selected={values.claimSettlementListOnAccount[index].utrDate}
                                                                                        onChange={(date) =>
                                                                                            setFieldValue(`claimSettlementListOnAccount.${index}.utrDate`, moment(date).format("YYYY-MM-DD"))
                                                                                        }
                                                                                        dateFormat="dd/MM/yyyy"
                                                                                        autoComplete="off"
                                                                                        className={`form-control ${touched.claimSettlementListOnAccount?.[index]?.utrDate &&
                                                                                            errors.claimSettlementListOnAccount?.[index]?.utrDate
                                                                                            ? "is-invalid"
                                                                                            : ""
                                                                                            } full-width-datepicker`}
                                                                                        name={`claimSettlementListOnAccount.${index}.utrDate`}
                                                                                        onBlur={() => setFieldTouched(`claimSettlementListOnAccount.${index}.utrDate`, true)}
                                                                                        placeholderText="Enter UTR Date"
                                                                                        minDate={new Date(parsedclaimIntimationDate)}
                                                                                        maxDate={new Date()}
                                                                                        // readOnly
                                                                                        onKeyDown={(e) => e.preventDefault()}
                                                                                    />
                                                                                    {touched.claimSettlementListOnAccount?.[index]?.utrDate &&
                                                                                        errors.claimSettlementListOnAccount?.[index]?.utrDate && (
                                                                                            <p className="errorMsg">{errors.claimSettlementListOnAccount[index].utrDate}</p>
                                                                                        )}
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                </div>
                                                            )}
                                                        </FieldArray>
                                                    </AccordionBody>
                                                </AccordionItem>
                                            </Accordion>}
                                        <div style={{ display: "flex", justifyContent: "end" }} className='mt-3'>
                                            <Button color="primary" type="submit" className="ITC_Blue_color" disabled={!dirty || isSubmitted || claimDetails?.claimStatus === "Withdrawn"}>
                                                Submit
                                            </Button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Form>
                    }}
                </Formik >
            </div>
            <hr />
            <div className='mt-3'>
                <div>
                    <Accordion>
                        <AccordionItem>
                            <AccordionHeader style={{ pointerEvents: 'none' }}>
                                <div>Salvage Amount</div>
                            </AccordionHeader>
                            <AccordionBody>
                                <div className="table-responsive option_01">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th className='sl-n'>Sl. No.</th>
                                                <th className="tbl-w-22">Amount</th>
                                                <th className='tbl-w-22'>UTR Date</th>
                                                <th className='tbl-w-3'>UTR Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {claimSettlementList?.salvageAmount?.length > 0 ? claimSettlementList?.salvageAmount?.map((list, index) => (
                                                <tr key={list.id}>
                                                    <td className='sl-n'>{index + 1}</td>
                                                    <td className="tbl-w-22">{list?.insurerApprovedAmount || '--'}</td>
                                                    <td className='tbl-w-22'>{formatDate(list?.utrDate) || "--"}</td>
                                                    <td className='tbl-w-3'>{list?.utrNumber || "--"}</td>
                                                </tr>
                                            )) : <p className='no-data text-center'>No Data Found</p>}
                                        </tbody>
                                    </Table>
                                </div>
                            </AccordionBody>
                        </AccordionItem>
                    </Accordion>
                </div>
                <div className='mt-3'>
                    <Accordion>
                        <AccordionItem>
                            <AccordionHeader style={{ pointerEvents: 'none' }}>
                                <div>On Account Payment</div>
                            </AccordionHeader>
                            <AccordionBody>
                                <div className="table-responsive option_01">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th className='sl-n'>Sl. No.</th>
                                                <th className="tbl-w-22">Amount</th>
                                                <th className='tbl-w-22'>UTR Date</th>
                                                <th className='tbl-w-3'>UTR Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {claimSettlementList?.accountPayments?.length > 0 ? claimSettlementList?.accountPayments?.map((list, index) => (
                                                <tr key={list.id}>
                                                    <td className='sl-n'>{index + 1}</td>
                                                    <td className="tbl-w-22">{list?.insurerApprovedAmount || '--'}</td>
                                                    <td className='tbl-w-22'>{formatDate(list?.utrDate) || "--"}</td>
                                                    <td className='tbl-w-3'>{list?.utrNumber || "--"}</td>
                                                </tr>
                                            )) : <p className='no-data text-center'>No Data Found</p>}
                                        </tbody>
                                    </Table>
                                </div>
                            </AccordionBody>
                        </AccordionItem>
                    </Accordion>
                </div>
                <div className='mt-3'>
                    <Accordion>
                        <AccordionItem>
                            <AccordionHeader style={{ pointerEvents: 'none' }}>
                                <div>Settlement Amount</div>
                            </AccordionHeader>
                            <AccordionBody>
                                <div className="table-responsive option_01">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th className='sl-n'>Sl. No.</th>
                                                <th className="tbl-w-17">Amount</th>
                                                <th className='tbl-w-28'>Re-Instatement/<br/>Adjustment Amount</th>
                                                <th className='tbl-w-22'>UTR Date</th>
                                                <th className='tbl-w-3'>UTR Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {claimSettlementList?.settledAmounts?.length > 0 ? claimSettlementList?.settledAmounts?.map((list, index) => (
                                                <tr key={list?.id}>
                                                    <td className='sl-n'>{index + 1}</td>
                                                    <td className="tbl-w-17">{list?.insurerApprovedAmount || '--'}</td>
                                                    <td className='tbl-w-28'>{list?.reInstatementPremium || '--'}</td>
                                                    <td className='tbl-w-22'>{formatDate(list?.utrDate) || "--"}</td>
                                                    <td className='tbl-w-3'>{list?.utrNumber || "--"}</td>
                                                </tr>
                                            )) : <p className='no-data text-center'>No Data Found</p>}
                                        </tbody>
                                    </Table>
                                </div>
                            </AccordionBody>
                        </AccordionItem>
                    </Accordion>
                </div>
            </div>
        </div >
    )
}
export default ClaimSettlement

